class Cards {
    flipCards: NodeListOf<HTMLElement>;

    constructor(){
        this.init();
    }

    init() {
        this.flipCards = document.querySelectorAll(".flip-card");
        this.flipCards.forEach(function(flip: HTMLElement){
            flip.dataset.flipped = "false";
            var transitionType = flip.dataset.transition;
            var inner = flip.querySelector(".flip-card-inner") as HTMLElement;
            var front = inner.querySelector(".flip-card-front") as HTMLElement;
            var frontBody = front.querySelector(".card-body") as HTMLElement;
            var back = inner.querySelector(".flip-card-back") as HTMLElement;
            var backBody = back.querySelector(".card-body") as HTMLElement;
            var flipbutton = flip.querySelector(".flip-card-button") as HTMLElement;
            
            // set card height
            var height = Math.round((backBody.offsetHeight / 16) + 11); // 11 is the height constant of everything else

            if (transitionType == "flip") {
                back.style.transform = "rotateY(180deg)";
            } else if (transitionType == "fade") {
                back.style.opacity = "0";
                front.style.transition = "opacity 0.3s ease-in-out";
                back.style.transition = "opacity 0.3s ease-in-out";
            }

            // do things
            back.style.position = "absolute";
            back.style.top = "0";
            // flip.style.height = `${height}rem`;
            // inner.dataset.frontSize = `${height}rem`;
            inner.dataset.backSize = `${height}rem`;

            flipbutton.addEventListener("click", function(event: MouseEvent) {
                var innerCard = inner;
                var flipCard = flip;
                var frontCard = front;
                var backCard = back;
                var checked = flip.dataset.flipped;
                var flipBtn = flipbutton;
                var transitionType = flip.dataset.transition;
                //rotateY(180deg)
                //opacity

                var flipTransition = function(innerCard: HTMLElement, frontCard: HTMLElement, backCard: HTMLElement, flipping: Boolean)
                {
                    if (flipping) {
                        innerCard.style.transform = "rotateY(180deg)";
                        backCard.style.transform = "rotateY(180deg)";
                    } else {
                        innerCard.style.transform = "";
                        backCard.style.transform = "rotateY(180deg)";
                    }
                }

                var fadeTransition = function(innerCard: HTMLElement, frontCard: HTMLElement, backCard: HTMLElement, flipping: Boolean)
                {
                    if (flipping) {
                        frontCard.style.opacity = "0";
                        backCard.style.opacity = "1";
                    } else {
                        frontCard.style.opacity = "1";
                        backCard.style.opacity = "0";
                    }
                }

                if (checked == "true") {
                    flipCard.dataset.flipped = "false";
                    flipCard.style.marginTop = "1rem";
                    innerCard.style.minHeight = "unset";
                    flipBtn.style.height = "100%";
                    if (transitionType == "fade") {
                        fadeTransition(innerCard, frontCard, backCard, false);
                    } else if(transitionType == "flip") {
                        flipTransition(innerCard, frontCard, backCard, false);
                    }
                } else {
                    flipCard.dataset.flipped = "true";
                    flipCard.style.marginTop = "2.5rem";
                    innerCard.style.minHeight = innerCard.dataset.backSize;
                    flipBtn.style.height = "4.5rem";

                    if (transitionType == "fade") {
                        fadeTransition(innerCard, frontCard, backCard, true);
                    } else if(transitionType == "flip") {
                        flipTransition(innerCard, frontCard, backCard, true);
                    }
                }
            });
        });
    }
}

export default Cards;
